<template>
    <div class="double-page-zoom-control"
         :style="data.styleZoomControl"
         v-if="deviceType() === 'desktop'"
        >
        <a class="btn-zoomout-double-page hover-effect"
           href="#"
           :class="data.classBtnZoomOut"
           :title="i18n.t('tooltip_zoomout')"
           @click.prevent="zoomOut"
        >
            <img class="full-size" src="~images/icon_zoomout.png">
        </a>
        <a class="btn-zoomin-double-page hover-effect"
           href="#"
           :class="data.classBtnZoomIn"
           :title="i18n.t('tooltip_zoomin')"
           @click.prevent="zoomIn"
        >
            <img class="full-size" src="~images/icon_zoomin.png">
        </a>
    </div>
</template>

<script>

    import {ref, reactive, onMounted, onUpdated, watchEffect, computed, inject}  from "vue"
    import {usePageResize} from "@/modules/reader/book/pageResize";
    import config from "@/config/config.json";
    import {isTouchDevice, deviceType} from "@/modules/utils/deviceUtils";

    export default {
        props: {
            side:String
        },
        setup(props, context) {

            const {pageResizeState, zoomInLeftPage, zoomOutLeftPage, zoomInRightPage, zoomOutRightPage } = usePageResize();
            const i18n = inject('i18n');

            const data = reactive({
                styleZoomControl: computed(()=>{

                    if (props.side === "left") {
                        return {
                           left:"0"
                        }
                    } else {
                        return {
                            right:"0"
                        }
                    }
                }),
                classBtnZoomIn: computed(()=> {
                    if (props.side === "left") {
                        return (pageResizeState.zoomLevelLeft === config.reader.maxZoom) ? "disabled" : ""
                    } else  if (props.side === "right") {
                        return (pageResizeState.zoomLevelRight === config.reader.maxZoom) ? "disabled" : ""
                    }
                }),
                classBtnZoomOut: computed(()=> {
                    if (props.side === "left") {
                        return (pageResizeState.zoomLevelLeft === config.reader.minZoom) ? "disabled" : ""
                    } else  if (props.side === "right") {
                        return (pageResizeState.zoomLevelRight === config.reader.minZoom) ? "disabled" : ""
                    }
                }),
            })

            const zoomIn = () => {

                if (props.side === "left") {
                    zoomInLeftPage();
                } else {
                    zoomInRightPage();
                }
            }

            const zoomOut = () => {

                if (props.side === "left") {
                    zoomOutLeftPage();
                } else {
                    zoomOutRightPage();
                }
            }

            return {
                i18n,
                data,
                pageResizeState,
                zoomIn,
                zoomOut,
                deviceType,
                isTouchDevice
            }
        }
    }
</script>

<style scoped lang="scss">

    .double-page-zoom-control {
        position:absolute;
        top:0;
        display:flex;
    }

    .btn-zoomin-double-page, .btn-zoomout-double-page  {
        width:$btn-main-func-size;
        height:$btn-main-func-size;
        display:block;
    }

</style>